import { Map, List } from 'immutable'

import {
  SEARCH, 
  CLEAR_SEARCH,
} from '../actions/search'

export default function search(state = {
  results: new List(),
  topic: null,
  query: null,
}, action) {
  switch (action.type) {
    case CLEAR_SEARCH:
      return {
        ...state,
        results: new List(),
        query: null,
        isSearching: false,
        facets: null
      }
    case SEARCH:
      return {
        ...state,
        ...action.payload,
        results: 'results' in action.payload ? state.results.concat(action.payload.results) : state.results,
      }
    default:
      return state
  }
}
